import {
    HISTORICO_ERROR,
    HISTORICO_LOADING,
    HISTORICO_SUCCESS,
  } from "../../../constants/ActionTypes";
  import axiosInstance from "../../../helpers/axiosInstance";
  
  export const getHistoricos = () => (dispatch) => {
    dispatch({
      type: HISTORICO_LOADING,
    });
  
    axiosInstance()
      .get("/MovCajaMedicoDoc/historico/60")
      .then((res) => {
        dispatch({
          type: HISTORICO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        dispatch({
          type: HISTORICO_ERROR,
          payload: err,
        });
      });
  };
  